export const CRITICAL_ERRORS = {
	DEM357: 'Algunos de los datos ingresados son inválidos. Por favor, verifica los campos e inténtalo nuevamente'
}
